import {
  Button,
  Container,
  Grid,
  LinearProgress,
  Theme,
  Typography,
  withStyles,
  WithStyles
} from '@material-ui/core'
import { TFunction } from 'i18next'
import moment from 'moment-timezone'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom'
import {
  change,
  Field,
  formValueSelector,
  getFormSubmitErrors,
  reduxForm,
  SubmissionError,
  untouch
} from 'redux-form'
import Talk from 'talkjs'
import {
  createApplicantAvailability,
  deleteApplicantAvailability
} from '../../../actions/applicantAvailability'
import { getConversation } from '../../../actions/applications'
import { closeDialog } from '../../../actions/dialogs'
import { navigate } from '../../../actions/routes'
import { CloseDialog } from '../../../actions/types'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import customCloseIcon from '../../../images/customCloseIcon.svg'
import {
  selectFutureAvailabilitiesByApplicant,
  selectIsAvailabilityCreating
} from '../../../selectors/applicantAvailability'
import { selectConversation } from '../../../selectors/applications'
import {
  selectReserve,
  selectReserveLoading
} from '../../../selectors/showings'
import { selectIsMobile, selectWindowWidth } from '../../../selectors/users'
import i18n from '../../../translations/i18n'
import { MuiClasses } from '../../../types'
import { AddApplicantAvailabilityFormData } from '../../../types/applicantAvailability'
import { ApplicationStatus } from '../../../types/applications'
import { ReduxForm } from '../../../types/forms'
import { ReserveInterface, StateInterface } from '../../../types/states'
import { bindSubmitActionToPromiseWithArgs } from '../../../utils/forms'
import {
  addPopup,
  get,
  getConversationById,
  initialize,
  TalkUser
} from '../../../utils/talkChat'
import ApplicationsApi from '../../../services/applications'
import {
  required,
  validateOnlyFutureEvents
} from '../../../utils/validation/forms'
import Suggest from '../../Apartment/Stepper/Steps/Suggest'
import Dialog from '../../Dialog'
import SuggestCustomCalendar from './Inputs/SuggestCustomCalendar'
import SuggestTimePickTable from './Inputs/SuggestTimePickTable'
import { UpdateStatusDialog } from './UpdateStatus'

const styles = ({ breakpoints, palette }: Theme) => ({
  section: {
    padding: '13px 10px'
  },
  primaryBtn: {
    font: '13px CircularRegular',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'center',
    textDecoration: 'none',
    backgroundColor: '#4f9b44',
    padding: '15px 0',
    color: '#fff',
    marginBottom: '15px',
    '&:hover': {
      backgroundColor: '#3f7c36'
    }
  },
  inviteButton: {
    background: '#4F9B44',
    boxShadow: 'none',
    height: '46px',
    width: '100%',
    padding: '15px 0',
    lineHeight: 'normal',
    borderRadius: '10px',
    marginBottom: '15px',
    '&:hover': {
      background: '#34782B'
    }
  },
  container: {
    maxWidth: '1151px',
    margin: '0',
    fontFamily: 'CircularRegular',
    display: 'flex',
    flexDirection: 'column' as const,
    '@media (max-width: 414px)': {
      width: '100%'
    }
  },
  formContainer: {
    maxWidth: '520px',
    margin: 'auto'
  },
  subContainer: {
    padding: '0',
    position: 'relative' as const
  },
  dateRangeContainer: {
    '& button': {
      width: 'calc(100% /7)',
      padding: '0'
    }
  },
  addBtn: {
    width: 'max-content',
    padding: '0.5rem 1.5rem',
    '& button': {
      background: 'rgb(106, 168, 79)',
      '&:hover': {
        background: 'rgb(84, 135, 62)'
      }
    }
  },
  title: {
    paddingTop: '20px',
    margin: '1rem 0rem 1rem 0rem',
    [breakpoints.down('sm')]: {
      fontSize: '1.2rem',
      paddingTop: '0'
    }
  },
  infoBlock: {
    display: 'flex',
    flexDirection: 'column' as const,
    marginBottom: '0.5rem'
  },
  infoTitle: {
    color: palette.grey[300],
    'text-transform': 'uppercase',
    fontSize: '0.7rem'
  },
  notInterestedButton: {
    margin: '0 auto 1rem 0',
    borderRadius: '10px',
    fontFamily: 'CircularBold',
    background: '#fff',
    color: '#D43838',
    textDecoration: 'underline' as const,
    padding: '0.5rem 1.5rem',
    boxShadow: 'none',
    '&:hover': {
      background: '#fff',
      color: '#D43838',
      boxShadow: 'none'
    }
  },
  textContainer: {
    margin: 'auto',
    padding: '0.35rem 24px 0 24px',
    maxWidth: '600px',
    marginBottom: '-1.65rem'
  },
  inActiveButton: {
    minWidth: '184px',
    maxWidth: '290px',
    backgroundColor: '#ffffff',
    color: '#000000',
    borderRadius: '6px',
    textTransform: 'none' as const,
    fontWeight: 'bold' as const,
    border: '1px solid #4f9b44',
    '& div': {
      width: '20px !important',
      height: '20px !important'
    },
    '& svg': {
      color: '#4f9b44'
    },
    '&:hover': {
      backgroundColor: '#e7e7e7'
    }
  },
  buttonsContainer: {
    marginTop: '35px'
  },
  button: {
    maxWidth: '200px',
    backgroundColor: '#4f9b44',
    minWidth: '80px',
    color: 'white',
    borderRadius: '6px',
    textTransform: 'none' as const,
    fontWeight: 'bold' as const,
    border: '1px solid #4f9b44',
    '& div': {
      width: '20px !important',
      height: '20px !important'
    },
    '& svg': {
      color: 'white'
    },
    '&:hover': {
      backgroundColor: '#93ce73',
      color: '#4f9b44'
    }
  },
  buttonsList: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    width: '100%',
    gap: '1rem',
    '& > button': {
      minWidth: '184px',
      maxWidth: '290px',
      '&.Mui-disabled': {
        backgroundColor: '#4f9b44 !important',
        color: 'rgba(0, 0, 0, 0.26)'
      }
    }
  },
  dialogModalBody: {
    width: '100%',
    boxSizing: 'border-box' as const,
    padding: '2rem 1.5rem 1.5rem 1.5rem',
    position: 'relative' as const
  },
  closeModalButton: {
    position: 'absolute' as const,
    top: '0.5rem',
    right: '0.5rem',
    opacity: 0.4,
    cursor: 'pointer',
    transition: 'opacity 500ms',
    fill: '#000000',
    '&:hover': {
      opacity: 0.8
    }
  },
  error: {
    color: '#f44336',
    margin: 0,
    marginBottom: '0.5rem',
    fontSize: '0.75rem',
    textAlign: 'center' as const,
    fontFamily: 'CircularRegular',
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: '0.03333em'
  },
  dialogSaveBtn: {
    font: '13px CircularRegular',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'center',
    textDecoration: 'none',
    padding: '15px 0',
    color: '#2f2f2f',
    boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.15)',
    textTransform: 'none' as const
  },
  modalTitle: {
    paddingTop: '5px',
    [breakpoints.down('sm')]: {
      fontSize: '1.2rem'
    }
  }
})

interface StateProps {
  reserve: ReserveInterface
  reserveLoading: boolean
  availabilities: any[]
  formValues: any
  _submitErrors: any
  isCreating: boolean
  isMobile: boolean
  windowWidth: string
  conversation: any
  getConversation: any
}
interface DispatchProps {
  createAvailabilityAction: (
    availability: AddApplicantAvailabilityFormData
  ) => void
  deleteAvailabilitiesAction: (
    apartmentId: string,
    applicationId: string,
    applicantAvailabilityId: string
  ) => void
  dispatch: Dispatch
  doNavigation: (path: string) => void
  changeDateTimeValue: any
  closeDialogAction: CloseDialog
}

type ComponentProps = StateProps &
  DispatchProps &
  WithTranslation &
  ReduxForm &
  WithStyles

type TalkSubscription = import('talkjs').Subscription

const validateIsTimeRangeExist = (
  newAvailability: any,
  myAvailabilities: any
) => {
  const availabilities = JSON.parse(JSON.stringify(myAvailabilities))

  if (availabilities.length <= 0) {
    return undefined
  }

  const startDate = moment(newAvailability.startDate).format('DD.MM.YYYY')

  const findAvailabilities = availabilities.filter(
    (availability: any) =>
      moment(availability.startDate).format('DD.MM.YYYY') === startDate
  )

  if (findAvailabilities.length === 0) {
    return undefined
  }

  const startTimeValue = moment(newAvailability.startTime)
    .seconds(0)
    .milliseconds(0)
    .valueOf()
  const endTimeValue = moment(newAvailability.endTime)
    .seconds(0)
    .milliseconds(0)
    .valueOf()

  const isValid = !findAvailabilities.some((availability: any) => {
    const oldStartTimeValue = moment(availability.startTime)
      .seconds(0)
      .milliseconds(0)
      .valueOf()
    const oldEndTimeValue = moment(availability.endTime)
      .seconds(0)
      .milliseconds(0)
      .valueOf()
    if (
      (startTimeValue >= oldStartTimeValue &&
        startTimeValue < oldEndTimeValue) ||
      (endTimeValue > oldStartTimeValue && endTimeValue <= oldEndTimeValue) ||
      (startTimeValue <= oldStartTimeValue && endTimeValue >= oldEndTimeValue)
    ) {
      return true
    }
    return false
  })
  return isValid ? undefined : i18n.t('error.showings.allowOnlyNewTimeRange')
}
const SuggestModal = ({
  classes,
  t,
  dialogId,
  closeDialogAction
}: {
  classes: MuiClasses
  t: TFunction
  dialogId: string
  closeDialogAction: CloseDialog
}) => {
  return (
    <Grid
      container
      justify='center'
      style={{ maxWidth: '800px', margin: 'auto' }}
    >
      <Typography variant='h5' align='center' className={classes.modalTitle}>
        {t('showings.reserve.suggestProceedAlready')}
      </Typography>
      <Grid item sm={12} style={{ margin: '15px 0 20px 0' }}>
        <Suggest
          isModal
          contentMaxWidth='800px'
          containerMaxWidth='800px'
          content={t('showings.reserve.hints.applicantLessThan3Applications')}
        />
      </Grid>

      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Button
            fullWidth
            className={classes.dialogSaveBtn}
            style={{ textTransform: 'uppercase' }}
            onClick={() => {
              window.open('https://fiksuvuokraus.fi/asuntonaytto', '_self')
            }}
          >
            {t('showings.reserve.otherApartments')}
          </Button>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Button
            variant='contained'
            fullWidth
            className={classes.primaryBtn}
            onClick={() => {
              closeDialogAction(dialogId)
            }}
          >
            {t('showings.reserve.hints.oneMoreShowing')}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
const SuggestShowingTimes = ({
  t,
  classes,
  reserve,
  handleSubmit,
  submitting,
  error,
  createAvailabilityAction,
  deleteAvailabilitiesAction,
  availabilities,
  dispatch,
  _submitErrors,
  isCreating,
  doNavigation,
  isMobile,
  closeDialogAction,
  formValues,
  changeDateTimeValue,
  windowWidth,
  conversation,
  getConversation
}: ComponentProps) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [toastShown, setToastShown] = useState(false);
  let chatPopup: Talk.Popup
  const isEnoughAvailabilities = new Set()
  for (const { startDate } of availabilities) {
    isEnoughAvailabilities.add(startDate)
    if (isEnoughAvailabilities.size > 3) break
  }
  const clearTime = useCallback(() => {
    dispatch(change('SuggestShowingTimesForm', 'time', undefined, false))
    dispatch(untouch('SuggestShowingTimesForm', 'time'))
  }, [dispatch])

  useEffect(() => {
    if (searchParams.has('showingCancelled') && !toastShown) {
      toast.info(t('showings.reserve.cancelSuccessToastMessage'));
      setToastShown(true);
    }
  }, [location, t, searchParams, toastShown]);

  const initiateConversation = async () => {
    const selfUserChat: TalkUser = {
      id: reserve.reserveData?.application.applicationId || '',
      name: reserve.reserveData?.application.name || '',
      // If the applicant is rejected, make chat read-only via TalkJS role
      role: reserve.reserveData?.application.status === ApplicationStatus.rejected ? 'applicant_readonly' : 'applicant'
    }
    await initialize(selfUserChat)

    const conversation = await getConversationById(
      reserve.reserveData?.application.applicationId || ''
    )

    // Explicitly set participant access to Read for rejected applicants
    if (reserve.reserveData?.application.status === ApplicationStatus.rejected) {
      try {
        const session = await get()
        // @ts-ignore TalkJS exposes `me` on the session instance
        const meUser = (session as any).me
        if (meUser && conversation?.setParticipant) {
          conversation.setParticipant(meUser, { access: 'Read' })
        }
      } catch (e) {
        // Silently ignore; we only want to prevent typing, not break UX
      }
    }

    return conversation
  }

  const showChatPopup = async (conversation: any): Promise<TalkSubscription> => {
    const session = await get()
    chatPopup = session.createPopup({
      launcher: 'never',
      showCloseInHeader: true,
      messageField: { enterSendsMessage: false }
    })
    let popupIsOpen = false

    chatPopup.onCustomConversationAction('delete', (event: any) => {
      ;(async () => {
        try {
          await ApplicationsApi.deleteTalkConversation(event.conversation.id)
        } catch (error) {
          console.error('Failed to delete conversation via backend', error)
        }
      })()
    })

    chatPopup.onOpen(() => {
      popupIsOpen = true
    })
    chatPopup.onClose(() => {
      popupIsOpen = false
    })

    chatPopup.select(conversation)
    chatPopup.mount({ show: false })
    addPopup(chatPopup)

    return session.unreads.onChange((unreadConversations) => {
      const unreadCount = Array.isArray(unreadConversations)
        ? unreadConversations.length
        : Number(unreadConversations) || 0

      if (unreadCount > 0 && !popupIsOpen) {
        popupIsOpen = true
        chatPopup.show()
      }
    })
  }

  useEffect(() => {
    let unreadSubscription: TalkSubscription | undefined

    const checkConversation = async () => {
      if (conversation?.conversation?.conversationData?.custom?.subject) {
        const conversation = await initiateConversation()
        if (conversation) {
          unreadSubscription = await showChatPopup(conversation)
        }
      }
    }

    checkConversation()

    return () => {
      unreadSubscription?.unsubscribe()
    }
  }, [conversation])

  useEffect(() => {
    if (reserve.reserveData?.application) {
      getConversation(reserve.reserveData?.application?.applicationId)
    }
  }, [reserve.reserveData?.application])

  const handleOnSubmit = (values: any) => {
    const data: AddApplicantAvailabilityFormData = {
      apartmentId: reserve.reserveData?.apartment.apartmentId,
      applicationId: reserve.reserveData?.application.applicationId,
      startDate: values.dateRange?.startDate,
      endDate: values.dateRange?.startDate,
      startTime: values.time.startTime.format(),
      endTime: values.time.endTime.format()
    }
    const timeRangeError = validateIsTimeRangeExist(data, availabilities)

    const startTimeError = validateOnlyFutureEvents(
      {
        startTime: values.time.startTime,
        endTime: values.time.endTime
      },
      values
    )
    const validateError = startTimeError || timeRangeError || undefined

    if (!validateError) {
      return createAvailabilityAction(data)
    } else {
      throw new SubmissionError({
        time: typeof validateError === 'string' ? validateError : ''
      })
    }
    clearTime()
  }

  const handleRemoveAvailability = (applicantAvailabilityId: any) => {
    const apartmentId = reserve.reserveData?.apartment.apartmentId
    const applicationId = reserve.reserveData?.application.applicationId
    if (apartmentId && applicationId) {
      deleteAvailabilitiesAction(
        apartmentId,
        applicationId,
        applicantAvailabilityId
      )
    }
  }
  // let errors = 0
  return (
    <Fragment>
      {reserve?.reserveData && (
        <Fragment>
          <Container className={classes.section}>
            <Container className={classes.subContainer}>
              <form onSubmit={handleSubmit(handleOnSubmit)}>
                <Grid container>
                  <Grid xs={12} sm={12} md={7}>
                    <Grid container className={classes.formContainer}>
                      {isMobile && (
                        <Grid sm={12} xs={12} md={5}>
                          <Suggest
                            contentMaxWidth='450px'
                            containerMaxWidth='450px'
                            content={t(
                              'showings.reserve.hints.applicantSuggestTime'
                            )}
                          />
                        </Grid>
                      )}
                      {/* {reserve?.reserveData.apartment.user && (
                        <Grid item xs={12}>
                          <Typography
                            variant='h5'
                            align='center'
                            className={classes.title}
                          >
                            {t('showings.reserve.landlordContactInfo')}
                          </Typography>
                          <Grid container direction="row" justify="center" alignItems="center">
                            <Typography align='center'>
                              {t('showings.reserve.name')}:&nbsp;
                            </Typography>
                            <Typography align='center' style={{ fontWeight: 'bold' }}>
                              {reserve?.reserveData.apartment.user.data.name}
                            </Typography>
                          </Grid>

                          <Grid container direction="row" justify="center" alignItems="center">
                            <Typography align='center'>
                              {t('showings.reserve.phoneNumber')}:&nbsp;
                            </Typography>
                            <Typography align='center' style={{ fontWeight: 'bold' }}>
                              {reserve?.reserveData.apartment.user.data.phoneNumber}
                            </Typography>
                          </Grid>
                        </Grid>
                      )} */}
                      <Grid item xs={12}>
                        <Typography
                          variant='h5'
                          align='center'
                          className={classes.title}
                        >
                          {t('showings.reserve.suggestDate')}
                        </Typography>
                        <Field
                          fullWidth
                          name='dateRange.startDate'
                          label={t('showings.createShowings.form.date')}
                          validate={[required]}
                          component={SuggestCustomCalendar}
                          disablePast={true}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        {formValues.dateRange &&
                          (windowWidth === 'sm' || windowWidth === 'xs') && (
                            <>
                              <Typography
                                variant='h5'
                                align='center'
                                className={classes.title}
                              >
                                {t('showings.reserve.suggestTimes')}{' '}
                                {moment(formValues.dateRange.startDate).format(
                                  'DD.MM'
                                )}
                              </Typography>
                              <Grid item xs={12} style={{ padding: '0 16px' }}>
                                <ErrorMessage error={error} />
                              </Grid>
                              <Field
                                fullWidth
                                name='time'
                                label={t('showings.createShowings.form.date')}
                                validate={[required]}
                                component={SuggestTimePickTable}
                                submittingLoad={submitting}
                                handleOnSubmit={handleOnSubmit}
                                handleSubmit={handleSubmit}
                                changeDateTimeValue={changeDateTimeValue}
                                removeAvailability={handleRemoveAvailability}
                                disablePast={true}
                              />
                            </>
                          )}
                      </Grid>

                      {submitting && <LinearProgress />}
                      <ErrorMessage error={error} />
                      <Grid item xs={12} className={classes.buttonsContainer}>
                        {isEnoughAvailabilities &&
                          isEnoughAvailabilities.size >= 3 ? (
                          <a
                            className={classes.primaryBtn}
                            style={{ textTransform: 'uppercase' }}
                            href='https://fiksuvuokraus.fi/asuntonaytto'
                          >
                            {t('showings.reserve.otherApartments')}
                          </a>
                        ) : (
                          <Dialog
                            buttonVariant='outlined'
                            dialogId='notEnoughShowings'
                            buttonLabel={t('showings.reserve.otherApartments')}
                            buttonClassName={classes.inviteButton}
                            Content={
                              <SuggestModal
                                classes={classes}
                                t={t}
                                dialogId='notEnoughShowings'
                                closeDialogAction={closeDialogAction}
                              />
                            }
                            customCloseIcon={customCloseIcon}
                            borderRadius='10px'
                            maxWidth='md'
                          />
                        )}

                        <UpdateStatusDialog
                          status={ApplicationStatus.notInterested}
                          noReservablesCase={false}
                          t={t}
                          buttonClassName={classes.notInterestedButton}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid sm={12} xs={12} md={5}>
                    {!isMobile && (
                      <Suggest
                        contentMaxWidth='450px'
                        containerMaxWidth='450px'
                        content={t(
                          'showings.reserve.hints.applicantSuggestTime'
                        )}
                      />
                    )}
                    {formValues.dateRange &&
                      (windowWidth === 'md' ||
                        windowWidth === 'lg' ||
                        windowWidth === 'xl') && (
                        <>
                          <Typography
                            variant='h5'
                            align='center'
                            className={classes.title}
                          >
                            {t('showings.reserve.suggestTimes')}{' '}
                            {moment(formValues.dateRange.startDate).format(
                              'DD.MM'
                            )}
                          </Typography>
                          <Grid item xs={12} style={{ padding: '0 16px' }}>
                            <ErrorMessage error={error} />
                          </Grid>
                          <Field
                            fullWidth
                            name='time'
                            label={t('showings.createShowings.form.date')}
                            validate={[required]}
                            component={SuggestTimePickTable}
                            submittingLoad={submitting}
                            handleOnSubmit={handleOnSubmit}
                            handleSubmit={handleSubmit}
                            changeDateTimeValue={changeDateTimeValue}
                            removeAvailability={handleRemoveAvailability}
                            disablePast={true}
                          />
                        </>
                      )}
                  </Grid>
                </Grid>
              </form>
            </Container>
          </Container>
        </Fragment>
      )}
    </Fragment>
  )
}

const selector = formValueSelector('SuggestShowingTimesForm')
const submitErrorsSelector = getFormSubmitErrors('SuggestShowingTimesForm')

const mapStateToProps = (state: StateInterface) => {
  return {
    reserveLoading: selectReserveLoading(state),
    reserve: selectReserve(state),
    availabilities: selectFutureAvailabilitiesByApplicant(state),
    _submitErrors: submitErrorsSelector(state),
    isCreating: selectIsAvailabilityCreating(state),
    formValues: selector(state, 'dateRange', 'time'),
    isMobile: selectIsMobile(state),
    windowWidth: selectWindowWidth(state),
    conversation: selectConversation(state)
  }
}

const mapDispatchToProps = (dispatch: Dispatch, { availability }: any) => ({
  dispatch,
  createAvailabilityAction: bindSubmitActionToPromiseWithArgs(
    dispatch,
    createApplicantAvailability,
    { availability }
  ),
  deleteAvailabilitiesAction: (
    apartmentId: string,
    applicationId: string,
    applicantAvailabilityId: string
  ) =>
    dispatch(
      deleteApplicantAvailability({
        apartmentId,
        applicationId,
        applicantAvailabilityId
      })
    ),
  doNavigation: (path: string) => dispatch(navigate(path)),
  changeDateTimeValue: (field: string, value: string) =>
    dispatch(change('SuggestShowingTimesForm', `${field}`, value)),
  closeDialogAction: (id: string) => dispatch(closeDialog(id)),
  getConversation: (applicationId: string) =>
    dispatch(getConversation(applicationId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'SuggestShowingTimesForm'
  })(withTranslation()(withStyles(styles)(SuggestShowingTimes) as any) as any)
)
